module.exports = __webpack_public_path__ + "img/1767.d14a0ea1.gif";